// extracted by mini-css-extract-plugin
export default {"searchBlock":"SearchInput_searchBlock__8ZbU-","searchInput":"SearchInput_searchInput__13I+L","button":"SearchInput_button__eeAFi"};